import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import ScratchClass from '@utils/scratch';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { Recommend } from 'src/common/recommend/Recommend';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsOrderPaySuccess.less';

export default class GoodsOrderPaySuccess extends OfficialPage {
  state = {
    status: 0, // 0: 普通页面 1:有集集乐的情况
    orderId: '',
    franchiseeId: '',
    collectBenefitData: {}, // 集集乐数据
    starData: [], //集集乐的星 light:已集样式 dark:未集样式
    isFail: true, //刮刮乐未中奖
    isWinning: true, //刮刮乐中奖
    isComfort: true, //刮刮乐安慰奖
    isWhole: true, //刮奖区域是否显示
    scratchId: '', //活动号
    isShowteam: false,
    winingTitle: '',
    isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
    ifWxCoupon: false,
    timestamp: '',
    signature: '',
    ifGetComfort: false,
    storeStyle: {}
  }

  recommendRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '支付成功';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    let that = this
    if (options.collectBenefit == 1) {
      that.getCollectBenefitData(options.detail)
      that.setData({
        status: 1
      })
    }
    that.setData({
      orderId: options.detail,
      franchiseeId: options.franchisee || '',
      is_group: options.is_group || '',
      code: options.code || '',
      is_newAppointment: options.is_newAppointment || '',
      isFranchisee: options.isFranchisee == 1 ? true : false // 是否是多商家多店结算
    })
    that.getOrderDetail()
    this.getAppECStoreConfig()
    that.getGoldenData(options.detail)
    let systemInfo = app.globalData.systemInfo || {}
    let width = (558 * systemInfo.windowWidth) / 750
    let height = (258 * systemInfo.windowWidth) / 750
    that.scratch = new ScratchClass(that, {
      canvasWidth: width,
      canvasHeight: height,
      imageResource:
        app.getSiteBaseUrl() +
        '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
      maskColor: 'red',
      r: 18,
      callback: () => {
        that.setData({
          hideCanvas: true
        })
        if (that.data.ifWxCoupon) {
          setTimeout(function() {
            that.toAddCard()
          }, 500)
        }
      },
      imgLoadCallback: () => {
        setTimeout(function() {
          that.setData({
            isShowteam: true
          })
        }, 10)
      }
    })
  }

  touchStart = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchMove = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchEnd = e => {
    if (!this.isStart) return
    let { canvasWidth, canvasHeight, minX, minY, maxX, maxY } = this
    if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
      this.ctx.draw()
      this.endCallBack && this.endCallBack()
      this.isStart = false
      this.page.setData({
        isScroll: true
      })
    }
  }
  getGoldenData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
      method: 'post',
      data: {
        order_id: id,
        sub_app_id: that.data.franchiseeId
      },
      success: function (data) {
        if (data.data) {
          if (that.data.code) {
            that.setData({
              isWhole: true
            })
          } else {
            that.setData({
              isWhole: false,
              scratchId: data.data
            })
          }
        } else {
          that.setData({
            isWhole: true
          })
        }
        if (data.integral) {
          //支付获取积分
          that.setData({
            rewardPointObj: {
              showModal: true,
              count: data.integral,
              callback: ''
            }
          })
        }
      }
    })
  }
  showAreaClick = () => {
    let that = this
    that.setData({
      isShowteam: false
    })
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      hideLoading: true,
      data: {
        activity_id: that.data.scratchId,
        sub_app_id: that.data.franchiseeId
      },
      success: function (res) {
        let data = res.data
        that.scratch.start()
        if (data.title == '谢谢参与') {
          that.setData({
            isFail: false
          })
        } else {
          let params = {
            ifWxCoupon: data.card_id || false,
            timestamp: data.timestamp || '',
            signature: data.signature || ''
          }
          if (data.is_comfort) {
            params['isComfort'] = false
          } else {
            params['isWinning'] = false
            params['winingTitle'] = data.title
          }
          that.setData(params)
        }
      }
    })
  }
  onShareAppMessage = res => {
    var that = this
    let franchiseeParam = this.data.franchiseeId
      ? '&franchisee=' + this.data.franchiseeId
      : ''
    return {
      path:
        '/awardManagement/pages/scratch/scratch?id=' +
        that.data.scratchId +
        franchiseeParam,
      success: function (res) {
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/getTime',
          data: {
            activity_id: that.data.scratchId,
            type: 'share',
            sub_app_id: that.data.franchiseeId
          },
          success: function (res) { }
        })
      },
      fail: function (res) { }
    }
  }
  getCollectBenefitData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
      data: {
        order_id: id,
        sub_app_id: that.data.franchiseeId
      },
      hideLoading: true,
      success: function (res) {
        let starData = []
        for (var i = 0; i < res.data.star_num; i++) {
          starData.push('light')
        }
        for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
          starData.push('dark')
        }
        that.setData({
          collectBenefitData: res.data,
          starData: starData
        })
      }
    })
  }
  goToHomepage = () => {
    let router = app.getHomepageRouter()
    app.reLaunch({
      url: '/pages/' + router + '/' + router
    })
  }
  goToOrderDetail = e => {
    let pickUpType = e.target.dataset.type || ''
    let path =
      pickUpType == 4
        ? 'diningOrderDetail/diningOrderDetail?detail='
        : 'goodsOrderDetail/goodsOrderDetail?detail='
    let that = this
    let pagePath =
      '/eCommerce/pages/' +
      path +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    let groupPath =
      '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    let appointmentPath =
      '/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    let newAppointmentPath =
      '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?detail=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '') +
      '&aptType=' +
      this.data.is_newAppointment
    let myOrderPage = `/eCommerce/pages/myOrder/myOrder?goodsType=0&currentIndex=0`
    if (this.data.is_group == 'true') {
      app.turnToPage(groupPath, true)
    } else if (this.data.code) {
      app.turnToPage(appointmentPath, true)
    } else if (this.data.is_newAppointment) {
      app.turnToPage(newAppointmentPath, true)
    } else if (this.data.isFranchisee) {
      app.turnToPage(myOrderPage, true)
    } else {
      app.turnToPage(pagePath, true)
    }
  }
  getOrderDetail = () => {
    var _this = this
    app.getOrderDetail({
      data: {
        order_id: _this.data.orderId,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.setData({
          orderInfo: res.data[0].form_data
        })
      }
    })
  }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      _this = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function (res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: true
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            sub_app_id: _data.franchisee,
            activity_id: _data.scratchId
          },
          success: function (res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
          }
        })
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config,
        hasRecommendConfig: res.recommend_config ? true : false
      })
    }, this.data.franchiseeId)
  }

  render() {
    let {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      storeStyle,
      orderInfo,
      hasRecommendConfig,
      collectBenefitData,
      starData,
      status,
      isWhole,
      isFail,
      isWinning,
      winingTitle,
      isComfort,
      ifGetComfort,
      ifWxCoupon,
      hideCanvas,
      scratch,
      isScroll,
      isShowteam,
      franchiseeId
    } = this.state

    // 防报错处理,小程序wxml是不存在这种问题,web端需要解决
    orderInfo = orderInfo || {};
    scratch = scratch || {};

    return (
      <div className="official-page goods-order-pay-success">
        <TopNav title="支付成功" />
        <div>
          {hasRecommendConfig && (
            <div className="normal-area">
              <div
                className="order-price-box"
                style={convertLineStyleData('background:' + storeStyle.theme)}
              >
                <div className="order-success">
                  <img
                    className="goods-complete-succes"
                    src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-success.png"
                  />
                  <span>支付成功</span>
                </div>
                <div className="order-price">
                  {'¥' + orderInfo.order_total_price}
                </div>
                <div className="btn-area">
                  <div onClick={this.goToHomepage}>继续购物</div>
                  <div
                    onClick={this.goToOrderDetail}
                    data-type={orderInfo.pick_up_type}
                  >
                    查看订单
                  </div>
                </div>
              </div>
              <img
                className="goods-complete-bg"
                src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-bg.png"
              />
            </div>
          )}
          {!hasRecommendConfig && (
            <React.Fragment>
              <div className="no-recommend-box">
                <div
                  className="normal-area"
                  style={convertLineStyleData('background:' + storeStyle.theme)}
                >
                  <img
                    className="goods-complete-succes"
                    src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/big-goods-complete-success.png"
                  />
                  <img
                    className="goods-complete-bg"
                    src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-bg.png"
                  />
                </div>
                <div
                  className="goods-complete-title"
                  style={convertLineStyleData('color:' + storeStyle.theme)}
                >
                  {'¥' + orderInfo.order_total_price}
                </div>
                <div className="slogan">支付成功</div>
                <div className="btn-area">
                  <div
                    className="go-on-shopping"
                    onClick={this.goToHomepage}
                    style={convertLineStyleData(
                      'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme
                    )}
                  >
                    继续购物
                  </div>
                  <div
                    onClick={this.goToOrderDetail}
                    data-type={orderInfo.pick_up_type}
                  >
                    查看订单
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {status == 1 && (
            <div className="collect-benefit-area">
              <div className="activity-box">
                <div className="line"></div>
                <div className="activity-title">活动</div>
                <div className="line"></div>
              </div>
              <div className="collect-item">
                <div className="star-num">
                  {'集集乐个数: ' + collectBenefitData.star_num}
                </div>
                <div className="star-list">
                  {starData.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {item == 'light' ? (
                          <img
                            className="star-item"
                            src={collectBenefitData.light_img}
                          />
                        ) : (
                            item == 'dark' && (
                              <img
                                className="star-item"
                                src={collectBenefitData.dark_img}
                              />
                            )
                          )}
                      </React.Fragment>
                    )
                  })}
                </div>
                {collectBenefitData.star_num ==
                  collectBenefitData.collect_num && (
                    <div className="star-full">
                      <div className="star-full-text">满</div>
                    </div>
                  )}
              </div>
              <div className="tip-item">
                {collectBenefitData.star_num ==
                  collectBenefitData.collect_num ? (
                    <div>{'获得一张' + collectBenefitData.coupon_title}</div>
                  ) : (
                    collectBenefitData.star_num !=
                    collectBenefitData.collect_num && (
                      <div>
                        {'消费' +
                          (collectBenefitData.play_type == 0 ? '每满' : '超过') +
                          collectBenefitData.value +
                          '元，累计一颗星，集满可获得' +
                          collectBenefitData.coupon_title +
                          '一张'}
                      </div>
                    )
                  )}
              </div>
            </div>
          )}
          {/*  刮刮乐  */}
          <div className="scratchWhole" hidden={isWhole}>
            <div className="activity-box scratch-activity">
              <div className="line"></div>
              <div className="activity-title">活动</div>
              <div className="line"></div>
            </div>
            <div className="scratchArea">
              <div className="scratchFail" hidden={isFail}>
                <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png" />
                <div className="failTitle">
                  <div className="failShare" onClick={this.shareClickEvent}>分享</div>
                  <div className="failText">很遗憾没有中奖哦</div>
                </div>
              </div>
              {/*  中奖  */}
              <div className="scratchWinning" hidden={isWinning}>
                <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png" />
                <div className="winningTitle">
                <div className="winningShare" onClick={this.shareClickEvent}>分享</div>
                  <div className="winningText">恭喜你获得了</div>
                  <div className="winningText winningValue">
                    {winingTitle}
                  </div>
                </div>
              </div>
              {/*  安慰奖  */}
              <div className="scratchComfort" hidden={isComfort}>
                <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png" />
                <div className="comfortTitle">
                  <div className="comfortShare" onClick={this.shareClickEvent}>分享</div>
                  {ifGetComfort ? (
                    <div className="comfortText">
                      已领取，在微信卡包中查看哦~
                    </div>
                  ) : (
                      <div className="comfortText" className="comfortText">
                        又没中奖，送你一个小礼品
                    </div>
                    )}
                  {!ifWxCoupon && !ifGetComfort && (
                    <div className="comfortText">
                      >在优惠券卡包进行查收哦~
                    </div>
                  )}
                </div>
              </div>
              <div
                className="scratch_wp"
                hidden={hideCanvas}
                style={convertLineStyleData(
                  'width: ' +
                  scratch.width +
                  'px; height: ' +
                  scratch.height +
                  'px;'
                )}
              >
                <canvas
                  className="scratch-canvas"
                  width={scratch && scratch.width}
                  height={scratch && scratch.height}
                  id="scratch-canvas"
                  onTouchStart={this.touchStart}
                  onTouchMove={this.touchMove}
                  onTouchEnd={this.touchEnd}
                ></canvas>
                {isShowteam && (
                  <div className="showArea">
                    <div className="showTitle">赢取优惠大奖</div>
                    <div className="showBtn" onClick={this.showAreaClick}>
                      点我刮奖
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Recommend id="component-recommend" franchiseeId={franchiseeId} ref={this.recommendRef} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-order-pay-success/GoodsOrderPaySuccess.jsx